// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BiPlus } from "react-icons/bi";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import Image from "@material-tailwind/react/Image";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Loading from "../../../components/loading/Loading";
import { alertService } from "../../../services/AlertService";
import { fetchPostMultipartSeaweed } from "../../../fetchers";
import { v4 as uuidv4 } from "uuid";
import man from "../../../assets/img/man.png";

import { Colors } from "../../../assets/Colors";
import "./KaryawanStyle.css";

import {
  getDetailKaryawan,
  getKaryawan,
  insertKaryawan,
  karyawanSelector,
  updateKaryawan,
} from "./karyawanSlice";

import {
  getMinProvinsi,
  provinsiSelector,
} from "../../master/provinsi/provinsiSlice";

import { getMinKota, kotaSelector } from "../../master/kota/kotaSlice";

import {
  getMinTipeKaryawan,
  tipeKaryawanSelector,
} from "../../master/tipe-karyawan/tipeKaryawanSlice";

import {
  bisnisUnitSelector,
  getMinBisnisUnit,
} from "../../master/bisnis-unit/bisnisUnitSlice";

import {
  getMinJabatan,
  jabatanSelector,
} from "../../master/jabatan/jabatanSlice";

import { bagianSelector, getMinBagian } from "../../master/bagian/bagianSlice";

import {
  getMinLokasiTugas,
  lokasiTugasSelector,
} from "../../master/lokasi-tugas/lokasiTugasSlice";

import { bankSelector, getMinBank } from "../../master/bank/bankSlice";

import {
  getMinGolongan,
  golonganSelector,
} from "../../master/golongan/golonganSlice";
import Select from "react-select";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Pie,
  PieChart,
  Sector,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function isRequired(value) {
  let status = false;
  if (value !== null) {
    if (typeof value === "number") {
      if (value !== -1) {
        status = true;
      }
    } else {
      if (value.trim().length > 0) {
        status = true;
      }
    }
  }
  return status;
}

function isSame(value1, value2) {
  return value1 === value2;
}

function useForm(
  initialState = {},
  validations = [],
  bankValidations = [],
  vstatus = {},
  onSubmit = () => {}
) {
  const { isValid: initialIsValid, errors: initialErrors } = validate(
    validations,
    bankValidations,
    initialState
  );
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState(initialErrors);
  const [isValid, setValid] = useState(initialIsValid);
  const [touched, setTouched] = useState({});

  const changeHandler = (event) => {
    // console.log(event);
    if (event.value) {
      const newValues = { ...values, [event.type]: event.value };
      const { isValid, errors } = validate(
        validations,
        bankValidations,
        newValues
      );
      setValues(newValues);
      setValid(isValid);
      setErrors(errors);
    } else {
      if (event.target.name === "StatusPajak") {
        let JmlAnak = 0;
        let JmlTanggungan = 0;
        switch (event.target.value) {
          case "2":
            JmlAnak += 1;
            break;

          case "3":
            JmlAnak += 2;
            break;

          case "4":
            JmlAnak += 3;
            break;
          case "5":
            JmlTanggungan += 1;
            break;
          case "6":
            JmlAnak += 1;
            JmlTanggungan += 1;
            break;

          case "7":
            JmlAnak += 2;
            JmlTanggungan += 1;
            break;

          case "8":
            JmlAnak += 3;
            JmlTanggungan += 1;
            break;
        }
        JmlTanggungan += JmlAnak;

        if (event.target.value > 4) {
          const newValues = {
            ...values,
            ["StatusPerkawinan"]: 2,
            [event.target.name]: event.target.value,
            ["JmlAnak"]: JmlAnak,
            ["JmlTanggungan"]: JmlTanggungan,
          };
          setValues(newValues);
        } else {
          const newValues = {
            ...values,
            ["StatusPerkawinan"]: 1,
            [event.target.name]: event.target.value,
            ["JmlAnak"]: JmlAnak,
            ["JmlTanggungan"]: JmlTanggungan,
          };
          setValues(newValues);
        }
      } else if (event.target.name === "Status") {
        const newValues = {
          ...values,
          [event.target.name]: event.target.checked ? "1" : "0",
        };
        setValues(newValues);
      } else {
        // if (event.target.name === "Status") {
        //   const newValues = {
        //     ...values,
        //     ["Status"]: "1",
        //   };
        //   const { isValid, errors } = validate(
        //     validations,
        //     bankValidations,
        //     newValues
        //   );
        //   setValues(newValues);
        //   setValid(isValid);
        //   setErrors(errors);
        //   setTouched({ ...touched, [event.target.name]: true });
        // } else {
        // }
        const newValues = {
          ...values,
          [event.target.name]: event.target.value,
        };
        const { isValid, errors } = validate(
          validations,
          bankValidations,
          newValues
        );
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
        setTouched({ ...touched, [event.target.name]: true });
      }
    }
  };
  const editHandler = (initValuesedit) => {
    const newValues = {
      ...values,
      Nik: initValuesedit.Nik,
      NamaKaryawan: initValuesedit.NamaKaryawan,
      TipeKaryawanID: initValuesedit.TipeKaryawanID,
      BisnisUnitID: initValuesedit.BisnisUnitID,
      TempatLahir: initValuesedit.TempatLahir,
      TanggalLahir: initValuesedit.TanggalLahir,
      Warganegara: initValuesedit.Warganegara,
      JenisKelamin: initValuesedit.JenisKelamin,
      Agama: initValuesedit.Agama,
      GolonganDarah: initValuesedit.GolonganDarah,
      Alamat: initValuesedit.Alamat,
      NoTlpn: initValuesedit.NoTlpn,
      NoHp: initValuesedit.NoHp,
      LevelPendidikan: initValuesedit.LevelPendidikan,
      Suku: initValuesedit.Suku,
      StatusPerkawinan: initValuesedit.StatusPerkawinan,
      StatusPajak: initValuesedit.StatusPajak,
      JmlAnak: initValuesedit.JmlAnak,
      JmlTanggungan: initValuesedit.JmlTanggungan,
      TanggalMasuk: initValuesedit.TanggalMasuk,
      JabatanID: initValuesedit.JabatanID,
      GolonganID: initValuesedit.GolonganID,
      BagianID: initValuesedit.BagianID,
      LokasiTugasID: initValuesedit.LokasiTugasID,
      SistemGaji: initValuesedit.SistemGaji,
      NoRekeningBank: initValuesedit.NoRekeningBank,
      BankID: initValuesedit.BankID,
      PemilikBank: initValuesedit.PemilikBank,
      NoKTP: initValuesedit.NoKTP,
      NPWP: initValuesedit.NPWP,
      BPJS: initValuesedit.BPJS,
      LokasiPenerimaan: initValuesedit.LokasiPenerimaan,
      ProvinsiID: initValuesedit.ProvinsiID,
      KotaID: initValuesedit.KotaID,
      PhotoUUID: initValuesedit.PhotoUUID,
      email: initValuesedit.email,
      KartuKeluarga: initValuesedit.KartuKeluarga,
      Status: initValuesedit.Status,
      PIN: initValuesedit.PIN,
    };
    const { isValid, errors } = validate(
      validations,
      bankValidations,
      newValues
    );
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
    // console.log(values);
  };

  const clearHandler = () => {
    setValues({
      Nik: "",
      NamaKaryawan: "",
      TipeKaryawanID: "",
      BisnisUnitID: "",
      TempatLahir: "",
      Warganegara: 1,
      JenisKelamin: -1,
      Agama: -1,
      GolonganDarah: "",
      Alamat: "",
      NoTlpn: "",
      NoHp: "",
      LevelPendidikan: -1,
      Suku: "",
      StatusPerkawinan: -1,
      StatusPajak: -1,
      JabatanID: "",
      GolonganID: "",
      BagianID: "",
      LokasiTugasID: "",
      SistemGaji: -1,
      NoRekeningBank: "",
      BankID: "",
      PemilikBank: "",
      NoKTP: "",
      NPWP: "",
      BPJS: "",
      ProvinsiID: "",
      KotaID: "",
      LokasiPenerimaan: "",
      KartuKeluarga: "",
      PhotoUUID: "",
      email: "",
      Status: "1",
      PIN: "",
    });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    onSubmit(values);
  };

  return {
    values,
    changeHandler,
    editHandler,
    clearHandler,
    isValid,
    errors,
    touched,
    submitHandler,
  };
}

function validate(validations, bankValidations, values) {
  if (values.SistemGaji === "1") {
    validations = [...validations, ...bankValidations];
  }

  const errors = validations
    .map((validation) => validation(values))
    .filter((validation) => typeof validation === "object");
  return {
    isValid: errors.length === 0,
    errors: errors.reduce((errors, error) => ({ ...errors, ...error }), {}),
  };
}

// TipeKaryawanID "Kontrak/PKWT" — wajib isi periode kontrak saat Tambah
// Karyawan (dicatat backend ke TKontrakKerja).
const TIPE_KARYAWAN_PKWT = "T0003";

// "YYYY-MM-DD" → Date lokal (new Date("YYYY-MM-DD") dibaca UTC → bisa mundur sehari).
const parseTanggalLokal = (str) => {
  if (!str) return "";
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d);
};

// Date → "YYYY-MM-DD" menurut kalender LOKAL perangkat. Menggantikan JSON.stringify(Date)
// (UTC): tengah malam WITA/WIB = sore hari sebelumnya di UTC → tanggal bisa tersimpan
// mundur sehari. "" bila kosong/invalid.
const formatTanggalLokal = (d) => {
  if (!(d instanceof Date) || isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// Pesan error dari respons backend (LogError {message}, error validator, atau jaringan).
const pesanGagalSimpan = (err) => {
  if (!err) return "Gagal menyimpan data karyawan";
  if (typeof err === "string") return err;
  return err.message || err.Message || "Gagal menyimpan data karyawan";
};

const KaryawanPage = () => {
  const [TanggalMasuk, setTanggalMasuk] = useState("");
  const [TanggalMulaiKontrak, setTanggalMulaiKontrak] = useState("");
  const [TanggalAkhirKontrak, setTanggalAkhirKontrak] = useState("");
  const [errorKontrak, setErrorKontrak] = useState("");
  // Kontrak PKWT aktif yang sedang diedit ("" = belum ada → dibuat baru).
  const [TKontrakKerjaID, setTKontrakKerjaID] = useState("");
  const [TanggalLahir, setTanggalLahir] = useState("");
  const [isValidTanggalMasuk, setIsValidTanggalMasuk] = useState(true);
  const [isValidTanggalLahir, setIsValidTanggalLahir] = useState(true);
  const [isCheckstatusEdit, setisCheckstatusEdit] = useState(false);
  const [ProvinsiID, setProvinsiID] = useState("");
  const [KotaID, setKotaID] = useState("");
  const [isValidProvinsiID, setIsValidProvinsiID] = useState(true);
  const [isValidKotaID, setIsValidKotaID] = useState(true);
  const [currentNik, setCurrentNik] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);

  const initialState = {
    Nik: "",
    NamaKaryawan: "",
    TipeKaryawanID: "",
    BisnisUnitID: "",
    TempatLahir: "",
    Warganegara: 1,
    JenisKelamin: -1,
    Agama: -1,
    GolonganDarah: "",
    Alamat: "",
    NoTlpn: "",
    NoHp: "",
    LevelPendidikan: -1,
    Suku: "",
    StatusPerkawinan: -1,
    StatusPajak: -1,
    JabatanID: "",
    GolonganID: "",
    BagianID: "",
    LokasiTugasID: "",
    SistemGaji: -1,
    NoRekeningBank: "",
    BankID: "",
    PemilikBank: "",
    NoKTP: "",
    NPWP: "",
    BPJS: "",
    ProvinsiID: "",
    KotaID: "",
    LokasiPenerimaan: "",
    KartuKeluarga: "",
    PhotoUUID: "",
    email: "",
    Status: "1",
    PIN: "",
  };

  const bankValidations = [
    ({ BankID }) =>
      isRequired(BankID) || {
        BankID: "Nama bank wajib diisi",
      },
    ({ NoRekeningBank }) =>
      isRequired(NoRekeningBank) || {
        NoRekeningBank: "Nomor rekening wajib diisi",
      },
    ({ PemilikBank }) =>
      isRequired(PemilikBank) || {
        PemilikBank: "Nama pemiliki rekening wajib diisi",
      },
  ];
  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";

    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {payload.name}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill="#333"
        >{`Jumlah ${value}`}</text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          dy={18}
          textAnchor={textAnchor}
          fill="#999"
        >
          {`(Rate ${(percent * 100).toFixed(2)}%)`}
        </text>
      </g>
    );
  };

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
    ({ NamaKaryawan }) =>
      isRequired(NamaKaryawan) || { NamaKaryawan: "Nama karyawan wajib diisi" },

    ({ TipeKaryawanID }) =>
      isRequired(TipeKaryawanID) || {
        TipeKaryawanID: "Tipe karyawan wajib diisi",
      },
    ({ BisnisUnitID }) =>
      isRequired(BisnisUnitID) || { BisnisUnitID: "Bisnis unit wajib diisi" },
    ({ TempatLahir }) =>
      isRequired(TempatLahir) || { TempatLahir: "Tempat lahir wajib diisi" },
    ({ JenisKelamin }) =>
      isRequired(JenisKelamin) || { JenisKelamin: "Jenis kelamin wajib diisi" },
    ({ Agama }) => isRequired(Agama) || { Agama: "Agama wajib diisi" },
    ({ GolonganDarah }) =>
      isRequired(GolonganDarah) || {
        GolonganDarah: "Golongan darah wajib diisi",
      },
    ({ Alamat }) => isRequired(Alamat) || { Alamat: "Alamat wajib diisi" },
    ({ NoHp }) =>
      isRequired(NoHp) || {
        NoHp: "Nomor HP wajib diisi",
      },
    ({ LevelPendidikan }) =>
      isRequired(LevelPendidikan) || {
        LevelPendidikan: "Jenjang pendidikan wajib diisi",
      },
    ({ Suku }) => isRequired(Suku) || { Suku: "Suku wajib diisi" },

    ({ StatusPajak }) =>
      isRequired(StatusPajak) || { StatusPajak: "Status pajak wajib diisi" },
    ({ KartuKeluarga }) =>
      isRequired(KartuKeluarga) || {
        KartuKeluarga: "Kartu Keluarga wajib diisi",
      },
    ({ JabatanID }) =>
      isRequired(JabatanID) || { JabatanID: "Jabatan wajib diisi" },
    ({ GolonganID }) =>
      isRequired(GolonganID) || { GolonganID: "Golongan wajib diisi" },
    ({ BagianID }) =>
      isRequired(BagianID) || { BagianID: "Bagian wajib diisi" },
    ({ LokasiTugasID }) =>
      isRequired(LokasiTugasID) || {
        LokasiTugasID: "Lokasi tugas wajib diisi",
      },
    ({ SistemGaji }) =>
      isRequired(SistemGaji) || { SistemGaji: "Sistem gaji wajib diisi" },
    ({ NoKTP }) =>
      isRequired(NoKTP) || {
        NoKTP: "Nomor KTP wajib diisi dan hanya angka",
      },
    ({ NPWP }) => isRequired(NPWP) || { NPWP: "NPWP wajib diisi" },
    ({ BPJS }) => isRequired(BPJS) || { BPJS: "BPJS wajib diisi" },
    ({ LokasiPenerimaan }) =>
      isRequired(LokasiPenerimaan) || {
        LokasiPenerimaan: "Lokasi penerimaan wajib diisi",
      },
    // Wajib di backend (validate:"required") — dulu tak dicek di form sehingga
    // simpan ditolak server tanpa pesan.
    ({ PIN }) => isRequired(PIN) || { PIN: "PIN wajib diisi" },
    ({ ProvinsiID }) =>
      isRequired(ProvinsiID) || { ProvinsiID: "Provinsi wajib diisi" },
  ];

  const {
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
  } = useForm(initialState, validations, bankValidations);
  const [buttonTouched, setButtonTouched] = useState(false);
  // true selama request simpan berjalan — cegah klik ganda & modal tertutup prematur.
  const [isSaving, setIsSaving] = useState(false);
  const npwpFormat = (nStr) => {
    return nStr.replace(
      /(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/,
      "$1.$2.$3.$4-$5.$6"
    );
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentData, setCurrentData] = useState({});
  const [karyawanImageStatus, setKaryawanImageStatus] = useState(false);
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(9);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("1"); // default: hanya karyawan Aktif
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imgData, setImgData] = useState(null);

  const karyawan = useSelector(karyawanSelector);

  const provinsi = useSelector(provinsiSelector);
  const kota = useSelector(kotaSelector);
  const tipeKaryawan = useSelector(tipeKaryawanSelector);
  const bisnisUnit = useSelector(bisnisUnitSelector);
  const jabatan = useSelector(jabatanSelector);
  const bagian = useSelector(bagianSelector);
  const lokasiTugas = useSelector(lokasiTugasSelector);
  const bank = useSelector(bankSelector);
  const golongan = useSelector(golonganSelector);

  useEffect(() => {
    dispatch(
      getKaryawan({
        start: start,
        count: count,
        search: search,
        statusFilter: statusFilter,
      })
    );
  }, [search, statusFilter]);

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      if (
        karyawan.isGetDetailSuccess &&
        !karyawan.isGetDetailFetching &&
        karyawan.detailData
      ) {
        if (karyawan.detailData[0]) {
          const initValues = {
            Nik: karyawan.detailData[0].Nik,
            NamaKaryawan: karyawan.detailData[0].NamaKaryawan,
            TipeKaryawanID: karyawan.detailData[0].TipeKaryawanID,
            BisnisUnitID: karyawan.detailData[0].BisnisUnitID,
            TempatLahir: karyawan.detailData[0].TempatLahir,
            TanggalLahir: karyawan.detailData[0].TanggalLahir,
            Warganegara: karyawan.detailData[0].Warganegara,
            JenisKelamin: karyawan.detailData[0].JenisKelamin,
            Agama: karyawan.detailData[0].Agama,
            GolonganDarah: karyawan.detailData[0].GolonganDarah,
            Alamat: karyawan.detailData[0].Alamat,
            NoTlpn: karyawan.detailData[0].NoTlpn,
            NoHp: karyawan.detailData[0].NoHp,
            LevelPendidikan: karyawan.detailData[0].LevelPendidikan,
            Suku: karyawan.detailData[0].Suku,
            StatusPerkawinan: karyawan.detailData[0].StatusPerkawinan,
            StatusPajak: karyawan.detailData[0].StatusPajak,
            TanggalMasuk: karyawan.detailData[0].TanggalMasuk,
            JabatanID: karyawan.detailData[0].JabatanID,
            GolonganID: karyawan.detailData[0].GolonganID,
            BagianID: karyawan.detailData[0].BagianID,
            LokasiTugasID: karyawan.detailData[0].LokasiTugasID,
            SistemGaji: karyawan.detailData[0].SistemGaji,
            NoRekeningBank: karyawan.detailData[0].NoRekeningBank,
            BankID: karyawan.detailData[0].BankID,
            PemilikBank: karyawan.detailData[0].PemilikBank,
            NoKTP: karyawan.detailData[0].NoKTP,
            NPWP: karyawan.detailData[0].NPWP,
            BPJS: karyawan.detailData[0].BPJS,
            LokasiPenerimaan: karyawan.detailData[0].LokasiPenerimaan,
            ProvinsiID: karyawan.detailData[0].ProvinsiID,
            KotaID: karyawan.detailData[0].KotaID,
            PhotoUUID: karyawan.detailData[0].PhotoUUID,
            email: karyawan.detailData[0].email,
            JmlAnak: karyawan.detailData[0].JmlAnak,
            JmlTanggungan: karyawan.detailData[0].JmlTanggungan,
            KartuKeluarga: karyawan.detailData[0].KartuKeluarga,
            Status: karyawan.detailData[0].Status,
            PIN: karyawan.detailData[0].PIN,
          };
          dispatch(
            getMinKota({
              search: "",
              provinsi: karyawan.detailData[0].ProvinsiID,
            })
          );

          editHandler(initValues);
          setProvinsiID(karyawan.detailData[0].ProvinsiID);
          setKotaID(karyawan.detailData[0].KotaID);
          // API mengirim "YYYY-MM-DDT00:00:00Z" → ambil bagian tanggal saja agar
          // tak bergeser zona waktu.
          setTanggalMasuk(
            parseTanggalLokal((karyawan.detailData[0].TanggalMasuk || "").slice(0, 10))
          );
          setTanggalLahir(
            parseTanggalLokal((karyawan.detailData[0].TanggalLahir || "").slice(0, 10))
          );
          setTKontrakKerjaID(karyawan.detailData[0].TKontrakKerjaID || "");
          setTanggalMulaiKontrak(
            parseTanggalLokal(karyawan.detailData[0].TanggalMulaiKontrak)
          );
          setTanggalAkhirKontrak(
            parseTanggalLokal(karyawan.detailData[0].TanggalAkhirKontrak)
          );
          setErrorKontrak("");

          if (karyawan.detailData[0].Status === "1") {
            var CheckstatusEdit = true;
          } else {
            var CheckstatusEdit = false;
          }
          // setValues(initValues);
          // console.log(values);
          setisCheckstatusEdit(CheckstatusEdit);
          setShowModalAdd(showModalEdit);
        }
      }
    }

    if (
      !karyawan?.isGetFetching &&
      karyawan.isGetSuccess &&
      firstLoading === false
    ) {
      setFirstLoading(true);
    }
  });

  let detailPhoto = imgData;
  if (
    selectedFile === null &&
    karyawan.isGetDetailSuccess === true &&
    karyawan.detailData
  ) {
    detailPhoto = karyawan.detailData[0].PhotoUUID;
  }
  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };
  if (!firstLoading || karyawan.isGetDetailFetching) {
    return <Loading />;
  } else {
    let dataPie = [];
    const COLORS = ["#0088FE", "#FF8042", "#00C49F", "#FFBB28"];
    let dataBar = [];
    let dataBarPendidikan = [];
    let dataBarGolongan = [];

    if (karyawan.data.DataKaryawan) {
      dataPie = [
        {
          name: "Pria",
          value: parseInt(karyawan.data.JenisKelamin[1].value),
        },
        {
          name: "Wanita",
          value: parseInt(karyawan.data.JenisKelamin[0].value),
        },
      ];

      karyawan.data.Umur.map(({ label, value }, index) => {
        dataBar.push({
          name: label,
          total: parseInt(value),
        });
      });
      karyawan.data.Jenjang.map(({ label, value }, index) => {
        dataBarPendidikan.push({
          name: label,
          total: parseInt(value),
        });
      });
      karyawan.data.Golongan.map(({ label, value }, index) => {
        dataBarGolongan.push({
          name: label,
          total: parseInt(value),
        });
      });
    }
    return (
      <div className="md:ml-64">
        <div className="flex flex-wrap my-2 mx-2 justify-center text-left">
          {karyawan.data.DataKaryawan === null ? null : (
            <>
              <div className="w-full md:w-2/5 xl:w-4/12 px-2 my-2 cursor-pointer">
                <div className="flex flex-row items-center border border-blue-400 rounded">
                  <div className="w-1/2 mx-4 my-4">
                    <div className={"text-2xl pb-2 ml-2 w-max"}>
                      Populasi bedasarkan jenis kelamin
                    </div>

                    <PieChart width={500} height={250}>
                      <Pie
                        activeIndex={activeIndex}
                        activeShape={renderActiveShape}
                        data={dataPie}
                        cx="50%"
                        cy="50%"
                        innerRadius={30}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey="value"
                        onMouseEnter={onPieEnter}
                      >
                        {dataPie.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-2/5 xl:w-4/12 px-2 my-2 cursor-pointer">
                <div className="flex flex-row items-start border border-blue-400 rounded">
                  <div className="w-1/2 mx-4 my-4">
                    <div className={"text-2xl pb-2 ml-2 w-max"}>
                      Populasi bedasarkan umur
                    </div>

                    <BarChart
                      width={500}
                      height={250}
                      data={dataBar}
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                      barSize={20}
                    >
                      <XAxis
                        dataKey="name"
                        scale="point"
                        padding={{ left: 10, right: 10 }}
                      />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <CartesianGrid strokeDasharray="3 3" />
                      <Bar
                        dataKey="total"
                        fill="#8884d8"
                        background={{ fill: "#eee" }}
                      />
                    </BarChart>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-2/5 xl:w-4/12 px-2 my-2 cursor-pointer">
                <div className="flex flex-row items-start border border-blue-400 rounded">
                  <div className="w-1/2 mx-4 my-4">
                    <div className={"text-2xl pb-2 ml-2 w-max"}>
                      Populasi bedasarkan pendidikan
                    </div>
                    <BarChart
                      width={500}
                      height={250}
                      data={dataBarPendidikan}
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                      barSize={20}
                    >
                      <XAxis
                        dataKey="name"
                        scale="point"
                        padding={{ left: 10, right: 10 }}
                      />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <CartesianGrid strokeDasharray="3 3" />
                      <Bar
                        dataKey="total"
                        fill="#8884d8"
                        background={{ fill: "#eee" }}
                      />
                    </BarChart>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 xl:w-1/2 px-2 my-2 cursor-pointer">
                <div className="flex flex-row items-start border border-blue-400 rounded">
                  <div className="w-full mx-4 my-4">
                    <div className={"text-2xl pb-2 ml-2 w-max"}>
                      Populasi bedasarkan Golongan
                    </div>
                    <BarChart
                      width={750}
                      height={250}
                      data={dataBarGolongan}
                      margin={{
                        top: 5,
                        bottom: 5,
                      }}
                      barSize={20}
                    >
                      <XAxis
                        dataKey="name"
                        scale="point"
                        padding={{ left: 10, right: 10 }}
                      />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <CartesianGrid strokeDasharray="3 3" />
                      <Bar
                        dataKey="total"
                        fill="#8884d8"
                        background={{ fill: "#eee" }}
                      />
                    </BarChart>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <hr className={"border border-black"} />

        <div className="flex w-full justify-between px-4 mt-4 flex-col sm:flex-row">
          <form>
            <div
              className="relative text-gray-800 border rounded-md"
              style={{ color: Colors.primary }}
            >
              <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                <button
                  type="submit"
                  className="p-1 outline-none shadow-outline"
                >
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    className="w-6 h-6"
                  >
                    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </button>
              </span>
              <input
                onChange={(e) => {
                  setSearch(e.target.value);
                  setStart(0);
                }}
                value={search}
                className="py-2 text-sm text-gray-800 rounded-md pl-10 pr-2 bg-white outline-none"
                placeholder="Cari Karyawan"
              />
            </div>
          </form>
          <select
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setStart(0);
            }}
            className="py-2 my-2 sm:my-0 text-sm text-gray-800 border rounded-md px-2 bg-white outline-none"
            style={{ color: Colors.primary }}
          >
            <option value="1">Aktif</option>
            <option value="0">Tidak Aktif</option>
            <option value="ALL">Semua</option>
          </select>
          <button
            onClick={() => {
              dispatch(getMinProvinsi({ search: "" }));
              dispatch(getMinTipeKaryawan({ search: "" }));
              dispatch(getMinBisnisUnit({ search: "" }));
              dispatch(getMinJabatan({ search: "" }));
              dispatch(getMinBagian({ search: "" }));
              dispatch(getMinLokasiTugas({ search: "" }));
              dispatch(getMinBank({ search: "" }));
              dispatch(getMinGolongan({ search: "" }));
              setTanggalMulaiKontrak("");
              setTanggalAkhirKontrak("");
              setTKontrakKerjaID("");
              setErrorKontrak("");
              setTanggalMasuk("");
              setTanggalLahir("");
              setIsValidTanggalMasuk(true);
              setIsValidTanggalLahir(true);
              setProvinsiID("");
              setKotaID("");
              setIsValidKotaID(true);
              setSelectedFile(null);
              setImgData(null);
              setButtonTouched(false);
              clearHandler();
              setisCheckstatusEdit(true);
              setShowModalAdd(true);
            }}
            className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
          >
            <BiPlus className="text-xl text-gray-800" />
            Tambah
          </button>
        </div>

        <div className="flex flex-wrap my-2 mx-2 justify-start">
          {karyawan.data.DataKaryawan === null
            ? null
            : karyawan.data.DataKaryawan.map((data) => (
                <div
                  key={data.Nik}
                  className="w-full md:w-2/5 xl:w-4/12 px-2 my-2 cursor-pointer"
                  onClick={() => {
                    setCurrentNik(data.Nik);
                    setSelectedFile(null);
                    setImgData(null);
                    setButtonTouched(false);
                    setIsValidTanggalMasuk(true);
                    setIsValidTanggalLahir(true);
                    setIsValidKotaID(true);
                    dispatch(getDetailKaryawan({ Nik: data.Nik }));
                    dispatch(getMinProvinsi({ search: "" }));
                    dispatch(getMinTipeKaryawan({ search: "" }));
                    dispatch(getMinBisnisUnit({ search: "" }));
                    dispatch(getMinJabatan({ search: "" }));
                    dispatch(getMinBagian({ search: "" }));
                    dispatch(getMinLokasiTugas({ search: "" }));
                    dispatch(getMinBank({ search: "" }));
                    dispatch(getMinGolongan({ search: "" }));
                    setShowModalEdit(true);
                  }}
                >
                  <div className="flex flex-row items-start border border-blue-400 rounded">
                    <div className="w-1/3 mx-4 my-4">
                      <Image
                        className="w-12 h-12"
                        src={
                          data.PhotoUUID.replace(/\s/g, "") === ""
                            ? man
                            : process.env.REACT_APP_API_URL +
                              "karyawanImage/" +
                              data.PhotoUUID
                        }
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = man; // prevents looping
                          currentTarget.src = man;
                        }}
                        rounded
                      />
                    </div>
                    <div className="w-full ml-2 mt-4">
                      <div className="mb-2 flex flex-col justify-start">
                        <div className="text-xs font-bold">NIK :</div>
                        <div>{data.Nik}</div>
                      </div>
                      <div className="mb-2 flex flex-col justify-start">
                        <div className="text-xs font-bold">Jabatan :</div>
                        <div>{data.NamaJabatan}</div>
                      </div>
                      <div className="mb-2 flex flex-col justify-start">
                        <div className="text-xs font-bold">Status :</div>
                        <div>
                          {data.Status === "1" ? "Aktif" : "Tidak Aktif"}
                        </div>
                      </div>
                    </div>
                    <div className="w-full mt-4 mr-4">
                      <div className="mb-2 flex flex-col justify-start">
                        <div className="text-xs font-bold">Nama :</div>
                        <div>{data.NamaKaryawan}</div>
                      </div>
                      <div className="mb-2 flex flex-col justify-start">
                        <div className="text-xs font-bold">Bagian :</div>
                        <div>{data.NamaBagian}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
        </div>
        <Modal
          size="regular"
          active={showModalAdd}
          toggler={() => {
            setShowModalAdd(true);
          }}
        >
          <ModalHeader
            className="mt-20"
            toggler={() => {
              setShowModalAdd(false);
              setShowModalEdit(false);
              setButtonTouched(false);
              setCurrentData({});
              clearHandler();
            }}
          >
            {showModalEdit ? "Edit Karyawan" : "Tambah Karyawan"}
          </ModalHeader>
          <ModalBody>
            <form className="w-full max-w-lg" onSubmit={submitHandler}>
              <div className="w-24 border-4 rounded-full mb-6">
                <Image
                  className="w-24"
                  src={
                    detailPhoto === null
                      ? man
                      : detailPhoto.replace(/\s/g, "") === ""
                      ? man
                      : process.env.REACT_APP_API_URL +
                        "karyawanImage/" +
                        detailPhoto
                  }
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = man; // prevents looping
                    currentTarget.src = man;
                  }}
                  rounded
                />
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Foto Karyawan
                  </label>
                  <input
                    type="file"
                    onChange={(e) => {
                      setSelectedFile(e.target.files[0]);
                      const reader = new FileReader();
                      reader.addEventListener("load", () => {
                        setImgData(reader.result);
                      });
                      reader.readAsDataURL(e.target.files[0]);
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    NIK {showModalEdit ? "" : "*"}
                  </label>
                  <input
                    value={values.Nik}
                    onChange={changeHandler}
                    name="Nik"
                    className={
                      (touched.Nik || buttonTouched) && errors.Nik
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                    disabled={showModalEdit ? true : false}
                  />
                  {(touched.Nik || buttonTouched) && errors.Nik && (
                    <p className="text-red-500 text-xs italic">{errors.Nik}</p>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    PIN {showModalEdit ? "" : "*"}
                  </label>
                  <input
                    value={values.PIN}
                    onChange={changeHandler}
                    name="PIN"
                    className={
                      (touched.PIN || buttonTouched) && errors.PIN
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                  />
                  {(touched.PIN || buttonTouched) && errors.PIN && (
                    <p className="text-red-500 text-xs italic">{errors.PIN}</p>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Is Active {showModalEdit ? "" : "*"}
                  </label>
                  <input
                    // value={values.Status}
                    name="Status"
                    type="checkbox"
                    // defaultChecked={isCheckstatusEdit}
                    checked={isCheckstatusEdit}
                    onClick={changeHandler}
                    onChange={(e) => {
                      setisCheckstatusEdit(e.target.checked);
                    }}

                    // {showModalAdd ? disabled : ''}
                    // disabled={showModalAdd ? true : false}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Nama *
                  </label>
                  <input
                    value={values.NamaKaryawan}
                    onChange={changeHandler}
                    name="NamaKaryawan"
                    className={
                      (touched.NamaKaryawan || buttonTouched) &&
                      errors.NamaKaryawan
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                  />
                  {(touched.NamaKaryawan || buttonTouched) &&
                    errors.NamaKaryawan && (
                      <p className="text-red-500 text-xs italic">
                        {errors.NamaKaryawan}
                      </p>
                    )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Tempat Lahir *
                  </label>
                  <input
                    value={values.TempatLahir}
                    onChange={changeHandler}
                    name="TempatLahir"
                    className={
                      (touched.TempatLahir || buttonTouched) &&
                      errors.TempatLahir
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                  />
                  {(touched.TempatLahir || buttonTouched) &&
                    errors.TempatLahir && (
                      <p className="text-red-500 text-xs italic">
                        {errors.TempatLahir}
                      </p>
                    )}
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Tanggal Lahir *
                  </label>
                  <DatePicker
                    className={
                      !isValidTanggalLahir
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    selected={TanggalLahir}
                    onChange={(date) => {
                      setTanggalLahir(date);
                      setIsValidTanggalLahir(true);
                    }}
                  />
                  {!isValidTanggalLahir && (
                    <p className="text-red-500 text-xs italic">
                      Tanggal lahir wajib diisi
                    </p>
                  )}
                </div>
              </div>

              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Jenis Kelamin *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.JenisKelamin}
                      onChange={changeHandler}
                      name="JenisKelamin"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.JenisKelamin || buttonTouched) &&
                        errors.JenisKelamin
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value={-1} hidden>
                        -- Pilih Data --
                      </option>
                      <option value={1}>Pria</option>
                      <option value={0}>Wanita</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.JenisKelamin || buttonTouched) &&
                      errors.JenisKelamin && (
                        <p className="text-red-500 text-xs italic">
                          {errors.JenisKelamin}
                        </p>
                      )}
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Agama *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.Agama}
                      onChange={changeHandler}
                      name="Agama"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.Agama || buttonTouched) && errors.Agama
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value={-1} hidden>
                        -- Pilih Data --
                      </option>
                      <option value={1}>Islam</option>
                      <option value={2}>Protestan</option>
                      <option value={3}>Katolik</option>
                      <option value={4}>Hindu</option>
                      <option value={5}>Buddha</option>
                      <option value={6}>Khonghucu</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.Agama || buttonTouched) && errors.Agama && (
                      <p className="text-red-500 text-xs italic">
                        {errors.Agama}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Tipe Karyawan *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.TipeKaryawanID}
                      onChange={changeHandler}
                      name="TipeKaryawanID"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.TipeKaryawanID || buttonTouched) &&
                        errors.TipeKaryawanID
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {tipeKaryawan.minData.map((item, i) => (
                        <option
                          key={item.TipeKaryawanID}
                          value={item.TipeKaryawanID}
                        >
                          {item.NamaTipeKaryawan}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.TipeKaryawanID || buttonTouched) &&
                      errors.TipeKaryawanID && (
                        <p className="text-red-500 text-xs italic">
                          {errors.TipeKaryawanID}
                        </p>
                      )}
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Lokasi Tugas *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.LokasiTugasID}
                      onChange={changeHandler}
                      name="LokasiTugasID"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.LokasiTugasID || buttonTouched) &&
                        errors.LokasiTugasID
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {lokasiTugas.minData.map((item, i) => (
                        <option
                          key={item.LokasiTugasID}
                          value={item.LokasiTugasID}
                        >
                          {item.NamaLokasiTugas}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.LokasiTugasID || buttonTouched) &&
                      errors.LokasiTugasID && (
                        <p className="text-red-500 text-xs italic">
                          {errors.LokasiTugasID}
                        </p>
                      )}
                  </div>
                </div>
              </div>

              {values.TipeKaryawanID === TIPE_KARYAWAN_PKWT && (
                  <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Tanggal Mulai Kontrak *
                      </label>
                      <DatePicker
                        className={
                          errorKontrak && !TanggalMulaiKontrak
                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        }
                        dateFormat="dd/MM/yyyy"
                        selected={TanggalMulaiKontrak}
                        selectsStart
                        startDate={TanggalMulaiKontrak}
                        endDate={TanggalAkhirKontrak}
                        onChange={(date) => {
                          setTanggalMulaiKontrak(date || "");
                          setErrorKontrak("");
                        }}
                      />
                    </div>
                    <div className="w-full md:w-1/2 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Tanggal Akhir Kontrak *
                      </label>
                      <DatePicker
                        className={
                          errorKontrak && !TanggalAkhirKontrak
                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        }
                        dateFormat="dd/MM/yyyy"
                        selected={TanggalAkhirKontrak}
                        selectsEnd
                        startDate={TanggalMulaiKontrak}
                        endDate={TanggalAkhirKontrak}
                        minDate={TanggalMulaiKontrak || null}
                        onChange={(date) => {
                          setTanggalAkhirKontrak(date || "");
                          setErrorKontrak("");
                        }}
                      />
                    </div>
                    {errorKontrak && (
                      <p className="w-full px-3 text-red-500 text-xs italic">
                        {errorKontrak}
                      </p>
                    )}
                    {showModalEdit && (
                      <p className="w-full px-3 mt-1 text-gray-500 text-xs italic">
                        {TKontrakKerjaID
                          ? `Mengubah periode kontrak aktif (${TKontrakKerjaID}). Perpanjangan kontrak baru lewat menu Kontrak Kerja.`
                          : "Belum ada data kontrak — isi untuk mencatat periode kontrak karyawan ini."}
                      </p>
                    )}
                  </div>
                )}

              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Bisnit Unit *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.BisnisUnitID}
                      onChange={changeHandler}
                      name="BisnisUnitID"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.BisnisUnitID || buttonTouched) &&
                        errors.BisnisUnitID
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {bisnisUnit.minData.map((item, i) => (
                        <option
                          key={item.BisnisUnitID}
                          value={item.BisnisUnitID}
                        >
                          {item.NamaBisnisUnit}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.BisnisUnitID || buttonTouched) &&
                      errors.BisnisUnitID && (
                        <p className="text-red-500 text-xs italic">
                          {errors.BisnisUnitID}
                        </p>
                      )}
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Bagian *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.BagianID}
                      onChange={changeHandler}
                      name="BagianID"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.BagianID || buttonTouched) && errors.BagianID
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {bagian.minData.map((item, i) => (
                        <option key={item.BagianID} value={item.BagianID}>
                          {item.NamaBagian}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.BagianID || buttonTouched) && errors.BagianID && (
                      <p className="text-red-500 text-xs italic">
                        {errors.BagianID}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Jabatan *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <Select
                      value={jabatan.minData.filter(
                        ({ value }) => value === values.JabatanID
                      )}
                      className={
                        (touched.JabatanID || buttonTouched) && errors.JabatanID
                          ? "block appearance-none block w-full border  text-gray-700  border-red-500 rounded   leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  border text-gray-700  border-gray-200 rounded leading-tight outline-none bg-white border-gray-500"
                      }
                      onChange={changeHandler}
                      options={jabatan.minData}
                    />
                    {(touched.JabatanID || buttonTouched) &&
                      errors.JabatanID && (
                        <p className="text-red-500 text-xs italic">
                          {errors.JabatanID}
                        </p>
                      )}
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Golongan *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.GolonganID}
                      onChange={changeHandler}
                      name="GolonganID"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.GolonganID || buttonTouched) &&
                        errors.GolonganID
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {golongan.minData.map((item, i) => (
                        <option key={item.GolonganID} value={item.GolonganID}>
                          {item.NamaGolongan}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.GolonganID || buttonTouched) &&
                      errors.GolonganID && (
                        <p className="text-red-500 text-xs italic">
                          {errors.GolonganID}
                        </p>
                      )}
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Lokasi Penerimaan *
                  </label>
                  <input
                    value={values.LokasiPenerimaan}
                    onChange={changeHandler}
                    name="LokasiPenerimaan"
                    className={
                      (touched.LokasiPenerimaan || buttonTouched) &&
                      errors.LokasiPenerimaan
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                  />
                  {(touched.LokasiPenerimaan || buttonTouched) &&
                    errors.LokasiPenerimaan && (
                      <p className="text-red-500 text-xs italic">
                        {errors.LokasiPenerimaan}
                      </p>
                    )}
                </div>

                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Tanggal Masuk *
                  </label>
                  <DatePicker
                    className={
                      !isValidTanggalMasuk
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    selected={TanggalMasuk}
                    onChange={(date) => {
                      setTanggalMasuk(date);
                      setIsValidTanggalMasuk(true);
                    }}
                  />
                  {!isValidTanggalMasuk && (
                    <p className="text-red-500 text-xs italic">
                      Tanggal masuk wajib diisi
                    </p>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Sistem Gaji *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.SistemGaji}
                      onChange={changeHandler}
                      name="SistemGaji"
                      className={
                        (touched.SistemGaji || buttonTouched) &&
                        errors.SistemGaji
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value={-1} hidden>
                        -- Pilih Data --
                      </option>
                      <option value={1}>Transfer</option>
                      <option value={2}>Cash</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.SistemGaji || buttonTouched) &&
                      errors.SistemGaji && (
                        <p className="text-red-500 text-xs italic">
                          {errors.SistemGaji}
                        </p>
                      )}
                  </div>
                </div>
                {values.SistemGaji === "1" && (
                  <div className="w-full md:w-1/2 px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nama Bank *
                    </label>
                    <div className="inline-block relative w-full  ">
                      <select
                        value={values.BankID}
                        onChange={changeHandler}
                        name="BankID"
                        className={
                          (touched.BankID || buttonTouched) && errors.BankID
                            ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                            : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        }
                      >
                        <option defaultValue disabled value="" hidden>
                          -- Pilih Data --
                        </option>
                        {bank.minData.map((item, i) => (
                          <option key={item.BankID} value={item.BankID}>
                            {item.NamaBank}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                          className="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                      </div>
                      {(touched.BankID || buttonTouched) && errors.BankID && (
                        <p className="text-red-500 text-xs italic">
                          {errors.BankID}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {values.SistemGaji === "1" && (
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nomor Rekening *
                    </label>
                    <input
                      value={values.NoRekeningBank}
                      onChange={changeHandler}
                      name="NoRekeningBank"
                      className={
                        (touched.NoRekeningBank || buttonTouched) &&
                        errors.NoRekeningBank
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="number"
                    />
                    {(touched.NoRekeningBank || buttonTouched) &&
                      errors.NoRekeningBank && (
                        <p className="text-red-500 text-xs italic">
                          {errors.NoRekeningBank}
                        </p>
                      )}
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nama Pemilik Rekening *
                    </label>
                    <input
                      value={values.PemilikBank}
                      onChange={changeHandler}
                      name="PemilikBank"
                      className={
                        (touched.PemilikBank || buttonTouched) &&
                        errors.PemilikBank
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="text"
                    />
                    {(touched.PemilikBank || buttonTouched) &&
                      errors.PemilikBank && (
                        <p className="text-red-500 text-xs italic">
                          {errors.PemilikBank}
                        </p>
                      )}
                  </div>
                </div>
              )}
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Status Pajak *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.StatusPajak}
                      onChange={changeHandler}
                      name="StatusPajak"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.StatusPajak || buttonTouched) &&
                        errors.StatusPajak
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value={-1} hidden>
                        -- Pilih Data --
                      </option>
                      <option value={1}>TK0</option>
                      <option value={2}>TK1</option>
                      <option value={3}>TK2</option>
                      <option value={4}>TK3</option>
                      <option value={5}>K0</option>
                      <option value={6}>K1</option>
                      <option value={7}>K2</option>
                      <option value={8}>K3</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.StatusPajak || buttonTouched) &&
                      errors.StatusPajak && (
                        <p className="text-red-500 text-xs italic">
                          {errors.StatusPajak}
                        </p>
                      )}
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Nomor NPWP *
                  </label>
                  <input
                    value={npwpFormat(values.NPWP)}
                    onChange={changeHandler}
                    name="NPWP"
                    className={
                      (touched.NPWP || buttonTouched) && errors.NPWP
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                  />
                  {(touched.NPWP || buttonTouched) && errors.NPWP && (
                    <p className="text-red-500 text-xs italic">{errors.NPWP}</p>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Jumlah Anak
                  </label>
                  <div className="inline-block relative w-full  ">
                    <div
                      className={
                        "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      {values.JmlAnak}
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Jumlah Tanggungan
                  </label>
                  <div className="inline-block relative w-full  ">
                    <div
                      className={
                        "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      {values.JmlTanggungan}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Nomor BPJS *
                  </label>
                  <input
                    value={values.BPJS}
                    onChange={changeHandler}
                    name="BPJS"
                    className={
                      (touched.BPJS || buttonTouched) && errors.BPJS
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="number"
                  />
                  {(touched.BPJS || buttonTouched) && errors.BPJS && (
                    <p className="text-red-500 text-xs italic">{errors.BPJS}</p>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Nomor KTP *
                  </label>
                  <input
                    value={values.NoKTP}
                    onChange={changeHandler}
                    name="NoKTP"
                    className={
                      (touched.NoKTP || buttonTouched) && errors.NoKTP
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="number"
                  />
                  {(touched.NoKTP || buttonTouched) && errors.NoKTP && (
                    <p className="text-red-500 text-xs italic">
                      {errors.NoKTP}
                    </p>
                  )}
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Kartu Keluarga *
                  </label>
                  <input
                    value={values.KartuKeluarga}
                    onChange={changeHandler}
                    name="KartuKeluarga"
                    className={
                      (touched.KartuKeluarga || buttonTouched) &&
                      errors.KartuKeluarga
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="number"
                  />
                  {(touched.KartuKeluarga || buttonTouched) &&
                    errors.KartuKeluarga && (
                      <p className="text-red-500 text-xs italic">
                        {errors.KartuKeluarga}
                      </p>
                    )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Email
                  </label>
                  <input
                    value={values.email}
                    onChange={changeHandler}
                    name="email"
                    className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    type="text"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Nomor HP *
                  </label>
                  <input
                    value={values.NoHp}
                    onChange={changeHandler}
                    name="NoHp"
                    className={
                      (touched.NoHp || buttonTouched) && errors.NoHp
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="number"
                  />
                  {(touched.NoHp || buttonTouched) && errors.NoHp && (
                    <p className="text-red-500 text-xs italic">{errors.NoHp}</p>
                  )}
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Nomor Telepon
                  </label>
                  <input
                    value={values.NoTlpn}
                    onChange={changeHandler}
                    name="NoTlpn"
                    className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    type="number"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Warga Negara
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.Warganegara}
                      onChange={changeHandler}
                      name="Warganegara"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.Warganegara || buttonTouched) &&
                        errors.Warganegara
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option value={1}>Warga Negara Indonesia</option>
                      <option value={2}>Warga Negara Asing</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Suku *
                  </label>
                  <input
                    value={values.Suku}
                    onChange={changeHandler}
                    name="Suku"
                    className={
                      (touched.Suku || buttonTouched) && errors.Suku
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                  />
                  {(touched.Suku || buttonTouched) && errors.Suku && (
                    <p className="text-red-500 text-xs italic">{errors.Suku}</p>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Jenjang Pendidikan *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.LevelPendidikan}
                      onChange={changeHandler}
                      name="LevelPendidikan"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        (touched.LevelPendidikan || buttonTouched) &&
                        errors.LevelPendidikan
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value={-1} hidden>
                        -- Pilih Data --
                      </option>
                      <option value={1}>SD</option>
                      <option value={2}>SMP</option>
                      <option value={3}>SMA / SMK</option>
                      <option value={4}>D1</option>
                      <option value={5}>D2</option>
                      <option value={6}>D3</option>
                      <option value={7}>S1</option>
                      <option value={8}>S2</option>
                      <option value={9}>S3</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.LevelPendidikan || buttonTouched) &&
                      errors.LevelPendidikan && (
                        <p className="text-red-500 text-xs italic">
                          {errors.LevelPendidikan}
                        </p>
                      )}
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Golongan Darah *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      value={values.GolonganDarah}
                      onChange={changeHandler}
                      name="GolonganDarah"
                      className={
                        (touched.GolonganDarah || buttonTouched) &&
                        errors.GolonganDarah
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      <option value={"A"}>A</option>
                      <option value={"B"}>B</option>
                      <option value={"AB"}>AB</option>
                      <option value={"O"}>O</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {(touched.GolonganDarah || buttonTouched) &&
                      errors.GolonganDarah && (
                        <p className="text-red-500 text-xs italic">
                          {errors.GolonganDarah}
                        </p>
                      )}
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Status Perkawinan *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <div
                      className={
                        "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      {values.StatusPerkawinan <= 0 &&
                        "Harap memilih Status Pajak"}
                      {values.StatusPerkawinan === 1 && "Belum Menikah"}
                      {values.StatusPerkawinan === 2 && "Menikah"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Alamat *
                  </label>
                  <input
                    value={values.Alamat}
                    onChange={changeHandler}
                    name="Alamat"
                    className={
                      (touched.Alamat || buttonTouched) && errors.Alamat
                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                    type="text"
                  />
                  {(touched.Alamat || buttonTouched) && errors.Alamat && (
                    <p className="text-red-500 text-xs italic">
                      {errors.Alamat}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Provinsi *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <Select
                      value={provinsi.minData.filter(
                        ({ value }) => value === values.ProvinsiID
                      )}
                      className={
                        (touched.ProvinsiID || buttonTouched) &&
                        errors.ProvinsiID
                          ? "block appearance-none block w-full  text-gray-700  border-red-500 rounded   leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700  border-gray-200 rounded leading-tight outline-none bg-white border-gray-500"
                      }
                      onChange={(e) => {
                        changeHandler(e);
                        dispatch(getMinKota({ search: "", provinsi: e.value }));
                        setKotaID("");
                      }}
                      options={provinsi.minData}
                    />
                    {(touched.ProvinsiID || buttonTouched) &&
                      errors.ProvinsiID && (
                        <p className="text-red-500 text-xs italic">
                          {errors.ProvinsiID}
                        </p>
                      )}

                    {isValidProvinsiID && (
                      <p className="text-red-500 text-xs italic">
                        {errors.ProvinsiID}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Kota *
                  </label>
                  <div className="inline-block relative w-full  ">
                    <select
                      disabled={values.ProvinsiID === ""}
                      value={KotaID}
                      onChange={(e) => {
                        setKotaID(e.target.value);
                        setIsValidKotaID(true);
                      }}
                      name="KotaID"
                      className={
                        !isValidKotaID
                          ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {kota.minData.map((item, i) => (
                        <option key={item.KotaID} value={item.KotaID}>
                          {item.NamaKota}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    {!isValidKotaID && (
                      <p className="text-red-500 text-xs italic">
                        Kota wajib diisi
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="red"
              buttonType="link"
              onClick={() => {
                if (isSaving) return;
                setButtonTouched(false);
                setShowModalAdd(false);
                setShowModalEdit(false);
                setCurrentData({});
                setSelectedFile(null);
                setImgData(null);
                clearHandler();
              }}
              ripple="dark"
            >
              Cancel
            </Button>

            <Button
              color={isValid && !isSaving ? "green" : "blueGray"}
              disabled={isSaving}
              onClick={async () => {
                if (isSaving) return;
                // Kumpulkan SEMUA kesalahan dulu (bukan hanya isValid) agar user
                // melihat field mana yang kurang; dulu tanggal/kota kosong tetap dikirim
                // dan ditolak server tanpa pesan.
                let ok = isValid;
                if (!isValid) setButtonTouched(true);
                if (!(TanggalMasuk instanceof Date)) {
                  setIsValidTanggalMasuk(false);
                  ok = false;
                }
                if (!(TanggalLahir instanceof Date)) {
                  setIsValidTanggalLahir(false);
                  ok = false;
                }
                if (!KotaID) {
                  setIsValidKotaID(false);
                  ok = false;
                }
                const isPKWT = values.TipeKaryawanID === TIPE_KARYAWAN_PKWT;
                // Tambah: wajib. Edit: opsional (data lama banyak yang belum
                // punya kontrak), tapi bila diisi harus lengkap.
                const adaKontrak =
                  isPKWT &&
                  (!showModalEdit ||
                    TanggalMulaiKontrak ||
                    TanggalAkhirKontrak);
                if (adaKontrak) {
                  if (!TanggalMulaiKontrak || !TanggalAkhirKontrak) {
                    setErrorKontrak("Tanggal mulai & akhir kontrak wajib diisi");
                    ok = false;
                  } else if (TanggalAkhirKontrak < TanggalMulaiKontrak) {
                    setErrorKontrak(
                      "Tanggal akhir kontrak tidak boleh sebelum tanggal mulai"
                    );
                    ok = false;
                  }
                }
                if (!ok) {
                  alertService.error(
                    "Data belum lengkap — periksa isian bertanda merah.",
                    { autoClose: true, keepAfterRouteChange: false }
                  );
                  return;
                }

                // Salinan baru — jangan mutasi `values` (Object.assign lama).
                const payload = {
                  ...values,
                  TanggalMasuk: formatTanggalLokal(TanggalMasuk),
                  TanggalLahir: formatTanggalLokal(TanggalLahir),
                  ProvinsiID: values.ProvinsiID,
                  KotaID: KotaID,
                  // Kolom Status smallint: "" ditolak DB → pakai status checkbox.
                  Status: isCheckstatusEdit ? "1" : "0",
                  // Diisi nama file hasil upload di bawah; kosong = foto lama dipertahankan.
                  PhotoUUID: "",
                  ...(adaKontrak
                    ? {
                        TKontrakKerjaID: TKontrakKerjaID,
                        TanggalMulaiKontrak: formatTanggalLokal(TanggalMulaiKontrak),
                        TanggalAkhirKontrak: formatTanggalLokal(TanggalAkhirKontrak),
                      }
                    : { TanggalMulaiKontrak: "", TanggalAkhirKontrak: "" }),
                };

                // Modal baru ditutup SETELAH server mengonfirmasi tersimpan; bila gagal,
                // isian tetap ada & pesan error server ditampilkan.
                setIsSaving(true);
                try {
                  // Foto disajikan layanan file_upload (/v1/karyawanImage → ./uploads),
                  // jadi diunggah ke sana dulu (pola sama lampiran Lembur); backend
                  // hanya menyimpan namanya. Dulu backend menulis ke folder lain →
                  // foto tak pernah tampil & simpan bisa gagal.
                  if (selectedFile) {
                    const namaFoto =
                      uuidv4() + "-" + selectedFile.name.replace(/[^A-Za-z0-9._-]/g, "_");
                    const fd = new FormData();
                    fd.append("file", selectedFile, namaFoto);
                    try {
                      await fetchPostMultipartSeaweed(fd);
                    } catch (e) {
                      throw { message: "Upload foto gagal (" + (e.message || "jaringan") + ")" };
                    }
                    payload.PhotoUUID = namaFoto;
                  }
                  await dispatch(
                    showModalEdit
                      ? updateKaryawan(payload)
                      : insertKaryawan(payload)
                  ).unwrap();
                  alertService.success(
                    showModalEdit
                      ? "Data karyawan berhasil diubah"
                      : "Karyawan baru berhasil disimpan",
                    { autoClose: true, keepAfterRouteChange: false }
                  );
                  setShowModalAdd(false);
                  setShowModalEdit(false);
                  setButtonTouched(false);
                  setSelectedFile(null);
                  setImgData(null);
                  setCurrentData({});
                  clearHandler();
                  dispatch(
                    getKaryawan({
                      start: start,
                      count: count,
                      search: search,
                      statusFilter: statusFilter,
                    })
                  );
                } catch (err) {
                  alertService.error(
                    "Gagal menyimpan: " + pesanGagalSimpan(err),
                    { autoClose: false, keepAfterRouteChange: false }
                  );
                } finally {
                  setIsSaving(false);
                }
              }}
              ripple={isValid ? "light" : ""}
            >
              {isSaving ? "MENYIMPAN..." : "SUBMIT"}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
};

export default KaryawanPage;
